import { onMounted, onUnmounted, ref } from 'vue'

export function useScrollAnimation(threshold = 0.1) {
  const isVisible = ref(false)
  let observer = null
  let elementRef = null

  const observe = (element) => {
    if (!element) return

    elementRef = element

    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            isVisible.value = true
            // Opcional: parar de observar após a primeira aparição
            // observer.unobserve(entry.target)
          }
        })
      },
      {
        threshold: threshold,
        rootMargin: '0px 0px -50px 0px'
      }
    )

    observer.observe(element)
  }

  onUnmounted(() => {
    if (observer && elementRef) {
      observer.unobserve(elementRef)
      observer.disconnect()
    }
  })

  return {
    isVisible,
    observe
  }
}
